import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import api from './api/axiosInstance';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar.js';
import { Table, Button, Badge, Row, Col, Container, Modal, Card, Image, Form } from 'react-bootstrap'; // ✅ Added Modal
import Breadcrumb from './Breadcrumb';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';
import defaultProfileImage from './assets/img/ic-img.svg'; // change this with default profile image
import Dropdown from 'react-bootstrap/Dropdown';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import icEdit from './assets/img/ic-edit.svg';
import CompanyAddGeneral from './CompanyAddGeneral';
import NavTabs from './NavTabs';
import icSucess from './assets/img/ic-celebration-circle.svg';
import Pagination from 'react-bootstrap/Pagination';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import icNoUsers from './assets/img/ic-empty-box.svg';
import { resolveMediaUrl } from './utils/mediaUrl';

const CompanyEditUsers = () => {
    const { id, cityId } = useParams();
    const location = useLocation();
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage, setUsersPerPage] = useState(10);
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
    
    const [logoPreview, setLogoPreview] = useState('');
    const [savedModalTitle, setSavedModalTitle] = useState('Update successful');
    const [savedModalMessage, setSavedModalMessage] = useState('General company information was updated successfully.');
    const [showSavedModal, setShowSavedModal] = useState(false);
    const [activityStatus, setActivityStatus] = useState(true); // ✅ Added state
    const [errors, setErrors] = useState({});
    const [logo, setLogo] = useState(null);
    const [originalLogoUrl, setOriginalLogoUrl] = useState('');
    const [forceRerenderKey, setForceRerenderKey] = useState(0);
    const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

    const noUsers = filteredUsers.length === 0;

    const [generalData, setGeneralData] = useState({
        logo: '',
        logoPreview: '',
        title: '',
        bestPlacetoWorkRating: '',
        accessLevel: '',
        url: '',
        bestPlacetoWorkDescription: '',
    });

    const [cityName, setCityName] = useState('');
    useEffect(() => {
        if (!cityId) return;
        api.get(`/api/cities/${cityId}`)
            .then(res => setCityName(res.data?.name || ''))
            .catch(err => console.error('Error fetching city for breadcrumb:', err));
    }, [cityId]);

    const cityBasePath = cityId
        ? location.pathname.includes('/city-edit-companies/')
            ? `/city-edit-companies/${cityId}/company/:id`
            : `/city-edit-jobs/${cityId}/company/:id`
        : null;
    const companyNavItems = cityBasePath
        ? [
            { to: cityBasePath, eventKey: 'companyInfo', label: 'Company Info', end: true },
            { to: `${cityBasePath}/hiring`, eventKey: 'hiringInfo', label: 'Hiring Info' },
            { to: `${cityBasePath}/users`, eventKey: 'users', label: 'Users' },
            { to: `${cityBasePath}/history`, eventKey: 'history', label: 'History of changes' },
        ]
        : [
            { to: '/company-edit/:id', eventKey: 'companyInfo', label: 'Company Info' },
            { to: '/company-edit-hiring/:id', eventKey: 'hiringInfo', label: 'Hiring Info' },
            { to: '/company-edit-users/:id', eventKey: 'users', label: 'Users' },
            { to: '/company-edit-history/:id', eventKey: 'history', label: 'History of changes' },
        ];

     useEffect(() => {
        // Fetch company data for editing
        const fetchCompanyData = async () => {
            try {
                const response = await api.get(`/api/companies/${id}`);
                const companyData = response.data;

                setActivityStatus(companyData.activityStatus ?? false); // ✅ Load activity status

                setGeneralData({
                    title: companyData.title || '',
                    url: companyData.url || '',
                    logo: companyData.logo || '',
                    logoPreview: companyData.logo || '',
                    accessLevel: companyData.accessLevel || '',
                    bestPlacetoWorkRating: companyData.bestPlacetoWorkRating || '',
                    bestPlacetoWorkDescription: companyData.bestPlacetoWorkDescription || '',
                    activityStatus: companyData.activityStatus ?? false,
                    createdAt: companyData.created_at || '',
                    updatedAt: companyData.updatedAt || '',
                    accountApprovalStatus: companyData.accountApprovalStatus || '',
                });

            } catch (error) {
                console.error('Error fetching company data:', error);
                alert('An error occurred while fetching company details.');
            }
        };

        fetchCompanyData();
    }, [id]);
    
    const handleGeneralChange = (e) => {
        const { name, value } = e.target;

        // ✅ Handle file separately
        if (name === 'logo' && value instanceof File) {
            setLogo(value);
            const fileUrl = URL.createObjectURL(value);
            setLogoPreview(fileUrl);

            setGeneralData((prevData) => ({
                ...prevData,
                logo: value,
                logoPreview: fileUrl,
            }));
            return;
        }

        setGeneralData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };
    
    const handleDeleteImage = () => {
        setLogo(null);
        setLogoPreview('fallback'); // we'll handle it in the child
        setGeneralData((prev) => ({
            ...prev,
            logo: '',
            logoPreview: 'fallback',
        }));
    };

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);


    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await api.get(`/api/users/by-company/${id}`);
                setUsers(response.data);
                setFilteredUsers(response.data); // Initialize with full list
            } catch (err) {
                console.error('Failed to fetch users:', err);
            }
        };

        fetchUsers();
    }, [id]);

    const sortUserByName = () => {

    }

    const sortUserByCountry = () => {
        
    }

    const sortUserByCity = () => {
        
    }
    
    const sortUserByType = () => {
        
    }

    const sortUserByOnboarding = () => {
        
    }

    const sortUserByStatus = () => {
        
    }

    const handleResetLogo = () => {
        setLogo(null);
        setLogoPreview(originalLogoUrl); // restore saved logo from DB
    };

    const validateGeneralFields = () => {
        const newErrors = {};

        if (!generalData.title.trim()) {
            newErrors.title = 'Company name is required.';
        }
        if (!generalData.url.trim()) {
            newErrors.url = 'Company website is required.';
        } else {
            const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
            if (!urlPattern.test(generalData.url.trim())) {
                newErrors.url = 'Please enter a valid URL.';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleGeneralSubmit = async (e) => {
        if (e) e.preventDefault();

        if (!validateGeneralFields()) return false;

        try {
            const data = new FormData();
            Object.keys(generalData).forEach((key) => {
                if (key === 'logo') {
                    if (logo) {
                        data.append('logo', logo);
                    }
                } else {
                    data.append(key, generalData[key]);
                }
            });

            const res = await api.put(`/api/companies/${id}/general`, data);

            const updated = res.data;
            setGeneralData((prev) => ({
                ...prev,
                ...updated,
                logoPreview: updated.logo || '',
            }));
            setLogoPreview(updated.logo || '');
            setLogo(null);
            setSavedModalTitle('Update successful');
            setSavedModalMessage('General company information was updated successfully.');
            setShowSavedModal(true);
            return true;
        } catch (error) {
            console.error('Error updating general information:', error);
            alert('An error occurred while updating general information.');
            return false;
        }
    };

    return (
        <>
            <Sidebar />
            <main className="main-content flex-grow-1">
                <Container>
                    <Row>
                        <Col>
                            <Breadcrumb cityName={cityName} companyName={generalData.title} />
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col>
                            <Card>
                                <Card.Body className="pt-0">
                                    <Row>
                                        <Col xs={12}>
                                            <>
                                                <Row>
                                                    <Col>
                                                        <Form onSubmit={handleGeneralSubmit}>
                                                            <CompanyAddGeneral
                                                                formData={generalData}
                                                                handleChange={handleGeneralChange}
                                                                logo={generalData.logoPreview}
                                                                errors={errors}
                                                                handleGeneralSubmit={handleGeneralSubmit}
                                                                isEditPage={true}
                                                                activityStatus={activityStatus}
                                                                handleResetLogo={handleResetLogo}
                                                                forceRerenderKey={forceRerenderKey}
                                                                setForceRerenderKey={setForceRerenderKey}
                                                                handleDeleteImage={handleDeleteImage}
                                                            />
                                                        </Form>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-5">
                                                    <Col>
                                                        <NavTabs items={companyNavItems} />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-5">
                                                    <Col><h2>Users</h2></Col>
                                                </Row>
                                            </>
                                        </Col>
                                    </Row>
                                    {noUsers ? (
                                        <Row>
                                            <Col md={12}>
                                                <Row className="mb-3">
                                                    <Col md={6} className="no-result offset-md-3 d-flex flex-column justify-content-center align-items-center text-center">
                                                        <Image src={icNoUsers} alt="No users" className="mb-4" />
                                                        <h2 className="mb-3">No company users yet.</h2>
                                                        <p className="mb-4">Your company users will be displayed here.</p>
                                                        <Button as={Link}  to="/user-add" variant="primary">Add user</Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row>
                                            <Col xs={12}>
                                                <Row>
                                                    <Col>
                                                        <div className="table-responsive list">
                                                            <Table>
                                                                <thead>
                                                                    <tr>
                                                                        <th className="th-fixed-company-user" onClick={sortUserByName} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Name
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-company-country" onClick={sortUserByCountry} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Country 
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-city" onClick={sortUserByCity} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                City
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-email">
                                                                            <div>
                                                                                Email
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-phone">
                                                                            <div>
                                                                                Phone
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-users" onClick={sortUserByType} style={{ cursor: 'pointer' }}>
                                                                            User Type
                                                                            <span>
                                                                                <FaCaretUp />
                                                                                <FaCaretDown />
                                                                            </span>
                                                                        </th>
                                                                        <th className="th-fixed-status"  onClick={sortUserByStatus} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Status
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {currentUsers.map((user) => (
                                                                        <tr key={user._id}>
                                                                            {/* <Link 
                                                                                to={`/user-edit/${user._id}`} 
                                                                                style={{ textDecoration: 'none', color: 'inherit', flex: '1' }} 
                                                                            > */}
                                                                                <td>
                                                                                    <div>
                                                                                        <img
                                                                                            src={user.profileImage ? resolveMediaUrl(user.profileImage) : defaultProfileImage}
                                                                                            alt={user.firstName}
                                                                                            className="round"
                                                                                        />
                                                                                        <span className="text-ellipsis text-ellipsis-company-user">
                                                                                            <strong>{user.firstName} {user.familyName}</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                <td>{user.country}</td>
                                                                                <td>{user.city}</td>
                                                                                <td>{user.email}</td>
                                                                                <td>{user.phone}</td>
                                                                                <td>{user.companyRole || 'n/a'}</td>
                                                                                <td>
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={
                                                                                            <Tooltip id={`tooltip-status-${user._id}`}>
                                                                                                {user.activityStatus ? "Active" : "Inactive"}
                                                                                            </Tooltip>
                                                                                        }
                                                                                    >
                                                                                        <Badge bg={user.activityStatus ? 'active' : 'inactive'}>
                                                                                            &nbsp;
                                                                                        </Badge>
                                                                                    </OverlayTrigger>
                                                                                </td>
                                                                            {/* </Link> */}
                                                                            <td>
                                                                                <Dropdown
                                                                                        drop="down"
                                                                                        align="end"
                                                                                        onToggle={(isOpen) => {
                                                                                            if (isOpen) {
                                                                                            requestAnimationFrame(() => window.dispatchEvent(new Event("resize"))); // ✅ force Popper update
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                    <Dropdown.Toggle variant="link" className="text-dark p-0">
                                                                                        <i className="bi bi-three-dots-vertical"></i>
                                                                                    </Dropdown.Toggle>

                                                                                    <Dropdown.Menu
                                                                                        renderOnMount
                                                                                        popperConfig={{ strategy: "fixed" }}
                                                                                        style={{ zIndex: 2000 }}
                                                                                    >
                                                                                        
                                                                                        {/* <Dropdown.Item as={Link} to={`/user-invite/${user._id}`} data-text="Invite to complete profile">
                                                                                            <img src={icUserEdit } alt="Invite to complete profile" />
                                                                                            Invite to complete profile
                                                                                        </Dropdown.Item> */}
                                                                                        <Dropdown.Item as={Link} to={`/user-edit/${user._id}`} data-text="Edit">
                                                                                            <img src={icEdit} alt="Edit" />
                                                                                            Edit
                                                                                        </Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {/* Pagination Row with Total Count, Items Per Page Selector & "Go to Page" Input */}
                                                <Row className="pagination-wrapper">
                                                    <Col className="d-flex align-items-center">
                                                        <span>
                                                            Total {filteredUsers.length} {filteredUsers.length === 1 ? 'user' : 'users'}
                                                        </span>
                                                        <Pagination>
                                                            <Pagination.Prev 
                                                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
                                                                disabled={currentPage === 1}
                                                            >
                                                                <BsChevronLeft />
                                                            </Pagination.Prev>
                                                            {[...Array(totalPages).keys()].map(number => (
                                                                <Pagination.Item 
                                                                    key={number + 1} 
                                                                    active={number + 1 === currentPage} 
                                                                    onClick={() => handlePageChange(number + 1)}
                                                                >
                                                                    {number + 1}
                                                                </Pagination.Item>
                                                            ))}
                                                            <Pagination.Next 
                                                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
                                                                disabled={currentPage === totalPages}
                                                            >
                                                                <BsChevronRight />
                                                            </Pagination.Next>
                                                        </Pagination>
                                                    </Col>
                                                    <Col className="pagination-controls">
                                                        <div className="pagination-controls-per-page">
                                                            <Form.Select
                                                                value={usersPerPage}
                                                                onChange={(e) => setUsersPerPage(Number(e.target.value))}
                                                            >
                                                                <option value="10">10 / page</option>
                                                                <option value="20">20 / page</option>
                                                                <option value="40">40 / page</option>
                                                            </Form.Select>
                                                        </div>
                                                        <label className="pagination-controls-goto-label" htmlFor="goto-page">
                                                            Go to
                                                        </label>
                                                        <Form.Control
                                                            className="pagination-controls-goto-input"
                                                            type="number"
                                                            value={currentPage}
                                                            onChange={(e) => {
                                                                const newPage = Number(e.target.value);
                                                                if (newPage >= 1 && newPage <= totalPages) {
                                                                    setCurrentPage(newPage); // ✅ Only valid pages
                                                                }
                                                            }}
                                                            onBlur={() => {
                                                                if (currentPage < 1) setCurrentPage(1);
                                                                if (currentPage > totalPages) setCurrentPage(totalPages);
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>

                                            </Col>
                                        </Row>
                                    
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </main>

            {/* Saved info Modal */}
            <Modal show={showSavedModal} onHide={() => setShowSavedModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Image
                        src={icSucess}
                        alt=""
                        className="d-block m-auto mb-4"
                    />
                    <h2 className="text-center mb-3">{savedModalTitle}</h2>
                    <p className="text-center">{savedModalMessage}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowSavedModal(false)}>OK</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};

export default CompanyEditUsers;